/**
 * Track-local API helpers for the profile/settings track.
 *
 * These endpoints exist on the backend and have shared-types DTOs, but were not
 * yet surfaced in the shared `@/api/Api.ts`. Per the ownership contract, new
 * endpoints for a track live in a track-local api file rather than editing the
 * shared Api.ts. iOS refs:
 *   - getLikedChapters → client-native/src/api/Api.ts  GET /auth/chapters/liked
 */
import { axiosInstance, AuthFuncParams } from "@/api/Api";
import type { GetLikedChaptersResponse } from "@shared_types";

/** GET /auth/chapters/liked — paginated liked-video thumbnails for the Liked tab. */
export async function getLikedChapters({
  authToken,
  data,
}: AuthFuncParams<{ page?: number; limit?: number }>): Promise<GetLikedChaptersResponse> {
  const response = await axiosInstance.get<GetLikedChaptersResponse>(
    "/auth/chapters/liked",
    {
      params: data,
      headers: { Authorization: `Bearer ${authToken}` },
    }
  );
  return response.data;
}
